import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=829a1f00&scoped=true&"
import script from "./FooterNav.vue?vue&type=script&lang=js&"
export * from "./FooterNav.vue?vue&type=script&lang=js&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=829a1f00&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829a1f00",
  null
  
)

export default component.exports